import React, { useState } from 'react'

import { NotificationConsentPrompt } from '@v2/domains/notification/components/NotificationConsentPrompt'
import { useForegroundNotifications } from '@v2/domains/notification/hooks/useForegroundNotifications'
import { useInitialNotificationReconciliation } from '@v2/domains/notification/hooks/useInitialNotificationReconciliation'
import { useNotificationBootstrap } from '@v2/domains/notification/hooks/useNotificationBootstrap'
import { selectIsOrganizationSwitching } from '@v2/domains/organization/selectors/organizationSwitch.selectors'
import {
  selectCurrentOrganization,
  selectUserMembership,
} from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

export const NotificationConsentView = ({
  shouldBlockRendering,
}: {
  shouldBlockRendering: boolean
}) => {
  const currentOrganization = useAppSelector(selectCurrentOrganization)
  const authStatus = useAppSelector((state) => state.auth.status)
  const membership = useAppSelector(selectUserMembership)
  const authMembershipId = useAppSelector((state) => state.auth.membershipId)
  const isOrganizationSwitching = useAppSelector(selectIsOrganizationSwitching)

  const canLoadNotifications =
    authStatus === 'authenticated' &&
    !!membership?.id &&
    membership.id === authMembershipId &&
    !!currentOrganization?.id &&
    !shouldBlockRendering &&
    !isOrganizationSwitching
  useNotificationBootstrap(canLoadNotifications)
  useForegroundNotifications(canLoadNotifications)
  const activeMembershipId = canLoadNotifications ? membership?.id : undefined
  const isToggleNotificationsViewActive =
    location.pathname.endsWith('/notifications')
  const [automaticConsentPromptState, setConsentContext] = useState({
    membershipId: activeMembershipId,
    suppressAutomaticConsentPrompt: isToggleNotificationsViewActive,
  })
  if (automaticConsentPromptState.membershipId !== activeMembershipId) {
    setConsentContext({
      membershipId: activeMembershipId,
      suppressAutomaticConsentPrompt: isToggleNotificationsViewActive,
    })
  } else if (
    isToggleNotificationsViewActive &&
    !automaticConsentPromptState.suppressAutomaticConsentPrompt
  ) {
    setConsentContext({
      ...automaticConsentPromptState,
      suppressAutomaticConsentPrompt: true,
    })
  }
  const notificationInvitation =
    useInitialNotificationReconciliation(activeMembershipId)

  return notificationInvitation &&
    !isToggleNotificationsViewActive &&
    !automaticConsentPromptState.suppressAutomaticConsentPrompt ? (
    <NotificationConsentPrompt
      key={`${notificationInvitation!.membershipId}:${
        notificationInvitation!.browserInstallationId
      }:${notificationInvitation!.permissionIssue ?? 'consent'}`}
      {...notificationInvitation}
    />
  ) : null
}
